import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Adicione um vídeo seu do Youtube contando um pouco da sua experiência como profissional. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_YoutubeInput = _resolveComponent("YoutubeInput")!
  const _component_FormButton = _resolveComponent("FormButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_YoutubeInput, {
      label: "Link do Youtube",
      value: _ctx.session?.formatted_intro_video_link,
      model: _ctx.v$.form.intro_video_link
    }, null, 8, ["value", "model"]),
    _createVNode(_component_FormButton, {
      label: "Concluir",
      form: _ctx.v$.form,
      loading: _ctx.submitting,
      disabled: _ctx.v$.invalid,
      onOnClick: _ctx.submit
    }, null, 8, ["form", "loading", "disabled", "onOnClick"])
  ]))
}